import * as React from 'react';

import { LanguageToCode } from '../../../lib/App';
import CommonSelect, { CommonSelectWrapperProps } from '../CommonSelect';

const LanguageSelect = ({
  multiple,
  placeholder = `Please select countr${multiple ? 'ies' : 'y'}`,
  onChange,
  value,
  ...props
}: CommonSelectWrapperProps) => {
  const languageValue = !value
    ? []
    : value.toString().replace('[', '').replace(']', '').split(',');

  function onLanguageChange(value: string | string[]): void {
    if (Array.isArray(value)) {
      onChange(`[${value.join(',')}]`);

      return;
    }

    onChange(value);
  }

  return (
    <CommonSelect
      {...{ placeholder, multiple, ...props }}
      onChange={onLanguageChange}
      value={languageValue}
      values={Object.keys(LanguageToCode).map((lang) => {
        return { key: LanguageToCode[lang], value: lang };
      })}
      idKey="key"
      valueFn={(item) => item.value}
      popupMatchSelectWidth={false}
    />
  );
};

export default LanguageSelect;
